import { jsx as _jsx } from "react/jsx-runtime";
import { stringify } from 'hub-http/helpers/params';
import { getFullUrl } from 'hubspot-url-utils';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { useContext } from 'react';
import { TrackerContext } from '../../context/TrackerContext';
import getLocation from '../../utils/getLocation';
import CUIButton from '../CUIButton/CUIButton';

const CUISignupButton = ({
  trackingUrl,
  trackingIdentifier,
  variant = 'secondary'
}) => {
  const location = getLocation();
  const params = {
    'hubs_signup-url': trackingUrl || `${location.origin}${location.pathname}`,
    'hubs_signup-cta': trackingIdentifier || null
  };
  const queryString = stringify(params);
  const {
    trackInteraction
  } = useContext(TrackerContext);
  return /*#__PURE__*/_jsx(CUIButton, {
    onClick: () => trackInteraction('signup button click', {
      identifier: trackingIdentifier
    }),
    as: "a",
    variant: variant // @ts-expect-error - this is actually a link
    ,
    href: `${getFullUrl('app')}/signup-hubspot/connect?${queryString}`,
    children: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "connect.signupCta"
    })
  });
};

export default CUISignupButton;